<script>
  import _ from 'lodash'

  export default {
    name: 'VGridformBlockSelect',
    props: {
      blocks: {
        type: Array,
        default: () => []
      },
      items: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        blockTypes: [],
        expanded: []
      }
    },

    computed: {
      tableHeader() {
        return [
          {text: 'Type', value: 'type', filter: value => {
            return this.blockTypes.includes(value)
          }},
          {text: 'Label', value: 'label'},
          {text: 'Group', value: 'group'},
          {text: 'Rating', value: 'rating'}
        ]
      },
      tableItems() {
        return this.blocks.map(block => {
          const group = _.get(block, 'fieldlist.initials')
          let rating
          if (block.rating) {
            rating = `${block.rating.min} / ${block.rating.max}`
          }
          block.type = block.type || 'text'
          return {
            ..._.pick(block, ['id', 'label', 'type', 'icon', 'items']),
            group,
            rating,
            typeLabel: this.i18n(`fields.${block.type}.label`)
          }
        })
      }
    },
    watch: {
      blockTypes(bt) {
        // console.log('bt', bt)
      }
    },

    mounted() {
      const blocksByType = _.groupBy(this.blocks, 'type')
      this.blockTypes = _.keys(blocksByType)
      // console.log('blocksByType', blocksByType)
      // console.log('this.blocks', this.blocks)
      // console.log('this.items', this.items)
      // console.log('this.tableItems', this.tableItems)
    },

    methods: {
      rowClass(item) {
        return ''
      },
      expandItem(item) {
        if (!this.expanded.includes(item)) this.expanded.push(item)
      },
      collapseItem(item) {
        this.expanded = this.expanded.filter(row => row !== item)
      },

      i18n(key) {
        return this.$vuetify.lang.t(`$vuetify.gfb.${key}`)
      }
    }
  }
</script>

<template>
  <VFlex class="vgfbs__flex">
    <VSheet width="100%" height="100%">
      <VRow class="mx-0 fill-height">
        <!-- Imports and Selections -->
        <VCol cols="4" style="height:100%;overflow:auto">
          <VContainer fluid class="pa-0">
            <VSheet>
              <VTreeview
                  v-model="blockTypes"
                  :items="items"
                  item-text="label"
                  open-on-click
                  dense
                  selectable
                  selection-type="leaf"
                  open-all
              >
                <template v-slot:prepend="{ item }">
                  <VIcon v-if="item && item.icon" small>{{ item.icon }}</VIcon>
                </template>
              </VTreeview>
            </VSheet>
          </VContainer>
        </VCol>
        <VCol cols="8" style="height:100%;overflow:auto">
          <VDataTable
              :headers="tableHeader"
              :items="tableItems"
              :items-per-page="-1"
              dense
              show-expand
              :expanded.sync="expanded"
          >
            <template v-slot:item="{ item, isExpanded }">
              <tr :class="rowClass(item)">
                <td v-if="!isExpanded"><VIcon v-if="item.items" @click.left="expandItem(item)">mdi-chevron-down</VIcon></td>
                <td v-else><VIcon v-if="item.items" @click.left="collapseItem(item)">mdi-chevron-up</VIcon></td>
                <td><VIcon small v-text="item.icon"/> {{ item.typeLabel }}</td>
                <td>{{ item.label }}</td>
                <td>{{ item.group }}</td>
                <td>{{ item.rating }}</td>
              </tr>
            </template>
            <!-- Expansion panel -->
            <template v-slot:expanded-item="{ item, headers }">
              <tr>
                <td :colspan="headers.length" class="pa-3">{{ item.items }}</td>
              </tr>
            </template>
          </VDataTable>
        </VCol>
      </VRow>
    </VSheet>
  </VFlex>
</template>

<style>
  .vgfbs__flex {
    height: 80vh;
  }
</style>
